import React from "react";
import { useRouter } from "next/router";

const PoojaNotFound = () => {
    
    const router = useRouter();
    
    return (
        <div className="flex flex-col items-center justify-center min-h-screen text-center px-4">
            <p className="text-7xl md:text-9xl font-bold text-[#bd7d81]">404</p>
            
            <img
                src="/icons/book-my-pooja.svg"
                alt="logo"
                className="w-32 md:w-48 h-24 md:h-24 mt-2"
            />
            
            <h1 className="text-2xl md:text-3xl font-bold mt-6">
                No Poojas Found
            </h1>
            
            <p className="text-lg text-gray-600 mt-4 w-3/4">
                This Pooja is not available for the selected language and location combination.
                <br />
                Please try selecting different language
            </p>
            
            <p className="text-lg mt-4 text-[#8A1C23] max-w-md">
                Let&apos;s guide you back to the main shrine
            </p>
            
            <div className="mt-10">
                <button 
                    onClick={() => { router.push("/") }} 
                    className="underline text-FooterColor text-xl"
                >
                    Return Home
                </button>
            </div>
        </div>
    );
}

export default PoojaNotFound;